module.exports = __webpack_public_path__ + "static/media/Icespire1.dfdcc74d.jpg";